import {
  INIT_SET_RAPORTY,
  SET_RAPORT_DATA,
  CLEAR_RAPORT_DATA,
  REMOVE_RAPORT
} from '../types';

export default (state = [], { type, payload }) => {
  switch (type) {
    case INIT_SET_RAPORTY:
      return payload;
    case SET_RAPORT_DATA: {
      const newState = state.map((e) => ({ ...e }));
      const itemToEditIndex = newState.findIndex((e) => e.id === payload.id);

      newState[itemToEditIndex].data = payload.data.raportData;
      newState[itemToEditIndex].groups = payload.data.groups;
      newState[itemToEditIndex].date = payload.data.date;

      return newState;
    }
    case REMOVE_RAPORT: {
      const newState = state.map((e) => ({ ...e }));
      const itemToEditIndex = newState.findIndex((e) => e.id === payload);

      newState.splice(itemToEditIndex, 1);

      return newState;
    }
    case CLEAR_RAPORT_DATA: {
      const newState = state.map((e) => ({ ...e }));
      const itemToEditIndex = newState.findIndex((e) => e.id === payload);

      delete newState[itemToEditIndex].data;
      delete newState[itemToEditIndex].groups;
      delete newState[itemToEditIndex].date;

      return newState;
    }
    default:
      return state;
  }
};
